export default __webpack_public_path__ + "static/media/team-1.1e2e9c49.png";